var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ExpansionPanels',{attrs:{"data":_vm.bets,"loading":_vm.loading}})
}
var staticRenderFns = []

export { render, staticRenderFns }